import React, { Component } from "react";
import Invoices from "../../api/Invoice";
import "./CountInvoice.css";

class CountInvoice extends Component {

    constructor(props) {
        super(props);
        this.state = {
            count: []
        }
    }

    componentDidMount() {
        Invoices.get('/get-invoice-count')
            .then(res => {
                this.setState({ count: res.data })
            })
            .catch(error => console.log(error));
    }

    render() {
        return (
            <div className="count-main-invoice">
                <div className="invoice-title">
                    TODAY'S INVOICES<br />GENERATED :
                </div>
                <div>
                    <span className="count-invoice">{this.state.count}</span>
                </div>
            </div>
        )
    }
}

export default CountInvoice;